import styled from "styled-components"

export const HighPriorityWrapper = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: end;
`
export const HighPriorityTitle = styled.div<{
    active: boolean
}>`
    position: relative;
    padding-right: 25px;
    color: ${(props) => (props.active ? props.theme.highPriorityActiveColor : props.theme.highPriorityInactiveColor)};
    
    & > div {
        position: absolute;
        right: 0;
        top: -4px;
    }
`
